export const male_clothes = [ //An array of each Shirt's ID, Atlas file, name, and Hem (if available). There are 58.
  {
    id: 'outfit1', //For shirts or pants, append _frontarm_lowerhalf, _frontarm_upperhalf, _chest, _backarm_lowerhalf, _backarm_upperhalf to find id of each div. 
                   //For pants, append _frontleg_upperhalf, _frontleg_lowerhalf, _frontleg_foot, _crotch, _backleg_upperhalf, _backleg_lowerhalf, _backleg_foot to find id of each class.
                   //For hats, append ??
    atlas: 'atlas02', //Append to atlas to find class.
    name: 'Advanced BoS' //Show name in textbox.
  },
  {
    id: 'outfit2',
    atlas: 'atlas02',
    name: 'Expert BoS'
  },
  {
    id: 'outfit3',
    atlas: 'atlas02',
    name: 'Clergy',
    hem: 1
  },
  {
    id: 'outfit4',
    atlas: 'atlas02',
    name: 'BoS'
  },
  {
    id: 'outfit5',
    atlas: 'atlas02',
    name: 'Baseball uniform'
  },
  {
    id: 'outfit6',
    atlas: 'atlas02',
    name: 'Battle armor'
  },
  {
    id: 'outfit8',
    atlas: 'atlas02',
    name: 'Tenpenny\'s suit'
  },
  {
    id: 'outfit9',
    atlas: 'atlas03',
    name: 'That\'s a Nice Shirt!'
  },
  {
    id: 'outfit10',
    atlas: 'atlas03',
    name: 'Sweater Vest with Tie'
  },
  {
    id: 'outfit11',
    atlas: 'atlas03',
    name: 'Sweater Vest'
  },
  {
    id: 'outfit12',
    atlas: 'atlas03',
    name: 'Flight Suit'
  },
  {
    id: 'outfit13',
    atlas: 'atlas03',
    name: 'Autumn\'s uniform',
    hem: 1
  },
  {
    id: 'outfit14',
    atlas: 'atlas03',
    name: 'Combat armor'
  },
  {
    id: 'outfit15',
    atlas: 'atlas03',
    name: 'Tunnel Snake\'s outfit'
  },
  {
    id: 'outfit16',
    atlas: 'atlas03',
    name: 'Ex Con\'s outfit'
  },
  {
    id: 'outfit17',
    atlas: 'atlas04',
    name: 'Confessor Cromwell\'s rags',
    hem: 1
  },
  {
    id: 'outfit18',
    atlas: 'atlas04',
    name: 'Elf outfit',
    hem: 1
  },
  {
    id: 'outfit19',
    atlas: 'atlas04',
    name: 'Motorcyle jacket'
  },
  {
    id: 'outfit20',
    atlas: 'atlas04',
    name: 'Business suit'
  },
  {
    id: 'outfit21',
    atlas: 'atlas04',
    name: 'Bowling shirt'
  },
  {
    id: 'outfit22',
    atlas: 'atlas04',
    name: 'Rad Suspenders'
  },
  {
    id: 'outfit23',
    atlas: 'atlas04',
    name: 'Pre-War Intellectual'
  },
  {
    id: 'outfit24',
    atlas: 'atlas04',
    name: 'Sci-fi fan outfit'
  },
  {
    id: 'outfit25',
    atlas: 'atlas05',
    name: 'Handyman jumpsuit'
  },
  {
    id: 'outfit26',
    atlas: 'atlas05',
    name: 'Wasteland gear'
  },
  {
    id: 'outfit27',
    atlas: 'atlas05',
    name: 'Formal wear'
  },
  {
    id: 'outfit28',
    atlas: 'atlas05',
    name: 'Ghost costume',
    hem: 1
  },
  {
    id: 'outfit29',
    atlas: 'atlas05',
    name: 'Tattered longcoat',
    hem: 1
  },
  {
    id: 'outfit30',
    atlas: 'atlas05',
    name: 'Flight suit'
  },
  {
    id: 'outfit31',
    atlas: 'atlas05',
    name: 'Radiation suit',
    hem: 1
  },
  {
    id: 'outfit32',
    atlas: 'atlas05',
    name: 'Eulogy Jones\' suit'
  },
  {
    id: 'outfit33',
    atlas: 'atlas06',
    name: 'Metal armor'
  },
  {
    id: 'outfit34',
    atlas: 'atlas06',
    name: 'Military fatigues'
  },
  {
    id: 'outfit35',
    atlas: 'atlas06',
    name: 'Lifeguard outfit'
  },
  {
    id: 'outfit36',
    atlas: 'atlas06',
    name: 'Sheriff\'s duster',
    hem: 1
  },
  {
    id: 'outfit37',
    atlas: 'atlas06',
    name: 'Medieval ruler outfit',
    hem: 1
  },
  {
    id: 'outfit38',
    atlas: 'atlas06',
    name: 'Lab coat',
    hem: 1
  },
  {
    id: 'outfit39',
    atlas: 'atlas06',
    name: 'Institute jumper'
  },
  {
    id: 'outfit40',
    atlas: 'atlas06',
    name: 'Vault suit'
  },
  {
    id: 'outfit41',
    atlas: 'atlas07',
    name: 'Minutemen uniform',
    hem: 1
  },
  {
    id: 'outfit42',
    atlas: 'atlas07',
    name: 'Raider armor'
  },
  {
    id: 'outfit43',
    atlas: 'atlas07',
    name: 'T-60 power armor'
  },
  {
    id: 'outfit44',
    atlas: 'atlas07',
    name: 'X-01 Mk VI power armor'
  },
  {
    id: 'outfit45',
    atlas: 'atlas07',
    name: 'T-45 power armor'
  },
  {
    id: 'outfit46',
    atlas: 'atlas07',
    name: 'T-51 power armor'
  },
  {
    id: 'outfit47',
    atlas: 'atlas07',
    name: 'Nightwear'
  },
  {
    id: 'outfit48',
    atlas: 'atlas07',
    name: 'Pilgrim outfit',
    hem: 1
  },
  {
    id: 'outfit49',
    atlas: 'atlas08',
    name: 'Swimsuit'
  },
  {
    id: 'outfit50',
    atlas: 'atlas08',
    name: 'Synth armor'
  },
  {
    id: 'outfit51',
    atlas: 'atlas08',
    name: 'Skeleton costume'
  },
  {
    id: 'outfit52-A',
    atlas: 'atlas08',
    name: 'Wasteland medic'
  },
      // {
      //   id: 'outfit52-B',
      //   atlas: 'atlas08',
      //   name: 'Surgeon outfit',
      // },
  {
    id: 'outfit53',
    atlas: 'atlas08',
    name: 'Junior officer uniform'
  },
  {
    id: 'outfit54',
    atlas: 'atlas08',
    name: 'Initiate robe',
    hem: 1
  },
  {
    id: 'outfit55',
    atlas: 'atlas08',
    name: 'Merc Gear',
    hem: 1
  },
  {
    id: 'outfit56',
    atlas: 'atlas08',
    name: 'Santa suit'
  },
  {
    id: 'outfit61',
    atlas: 'atlas09',
    name: 'Armored vault suit'
  },
  {
    id: 'outfit62',
    atlas: 'atlas09',
    name: 'Leather armor'
  },
  {
    id: 'outfit63',
    atlas: 'atlas09',
    name: 'Three Dog\'s outfit'
  },
  {
    id: 'outfit64',
    atlas: 'atlas09',
    name: 'Treasure hunter gear'
  }

  // {
  //   id: 'outfit999',
  //   atlas: 'mysterious',
  //   name: 'Mysterious Stranger',
  //   hem: 1
  // }
  //,
  // {
  //   id: 'outfit1000',
  //   atlas: 'feral_ghoul',
  //   name: 'Feral Ghoul',
  // }
];